import { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getStoredPlaidLinkSession, usePlaidBankLink } from "hooks/usePlaidBankLink.ts";

// Return page for OAuth banks: reopens the stored Link session, then goes back where it started.
const PlaidOAuthPage = () => {
  const navigate = useNavigate();
  const [session] = useState(getStoredPlaidLinkSession);

  const goBack = useCallback(() => {
    navigate(session?.returnUrl || "/profile", { replace: true });
  }, [navigate, session]);

  usePlaidBankLink({ resumedSession: session, onFinished: goBack });

  useEffect(() => {
    if (!session) {
      goBack();
    }
  }, [session, goBack]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
      <Spinner animation="border" variant="light" />
    </div>
  );
};

export default PlaidOAuthPage;
